import { render, staticRenderFns } from "./CurriculumListEEC.vue?vue&type=template&id=7633a88e&scoped=true&"
import script from "./CurriculumListEEC.vue?vue&type=script&lang=ts&"
export * from "./CurriculumListEEC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7633a88e",
  null
  
)

export default component.exports